// GPA scale and mapping for COMSATS University Islamabad (Current/Old Policy)
// This will be updated once the user shares the new policy details.

export const GRADE_POINTS = {
  "A+": 4.0,
  "A": 4.0,
  "A-": 3.67,
  "B+": 3.33,
  "B": 3.0,
  "B-": 2.67,
  "C+": 2.33,
  "C": 2.0,
  "C-": 1.67,
  "D+": 1.33,
  "D": 1.0,
  "F": 0.0,
};

// Map from a WHOLE percentage (policy-rounded) to GPA band
export const percentToPoint = (pctInteger) => {
  if (pctInteger >= 85) return GRADE_POINTS["A"];
  if (pctInteger >= 80) return GRADE_POINTS["A-"];
  if (pctInteger >= 75) return GRADE_POINTS["B+"];
  if (pctInteger >= 71) return GRADE_POINTS["B"];
  if (pctInteger >= 68) return GRADE_POINTS["B-"];
  if (pctInteger >= 64) return GRADE_POINTS["C+"];
  if (pctInteger >= 61) return GRADE_POINTS["C"];
  if (pctInteger >= 58) return GRADE_POINTS["C-"];
  if (pctInteger >= 54) return GRADE_POINTS["D+"];
  if (pctInteger >= 50) return GRADE_POINTS["D"];
  return GRADE_POINTS["F"];
};

export const GRADE_SCALE_DISPLAY = [
  { grade: "A", points: "3.67 – 4.00", percent: "85 and above" },
  { grade: "A-", points: "3.34 – 3.66", percent: "80 – 84" },
  { grade: "B+", points: "3.01 – 3.33", percent: "75 – 79" },
  { grade: "B", points: "2.67 – 3.00", percent: "71 – 74" },
  { grade: "B-", points: "2.34 – 2.66", percent: "68 – 70" },
  { grade: "C+", points: "2.01 – 2.33", percent: "64 – 67" },
  { grade: "C", points: "1.67 – 2.00", percent: "61 – 63" },
  { grade: "C-", points: "1.31 – 1.66", percent: "58 – 60" },
  { grade: "D+", points: "1.01 – 1.30", percent: "54 – 57" },
  { grade: "D", points: "0.10 – 1.00", percent: "50 – 53" },
  { grade: "F", points: "0.00", percent: "Below 50" },
];
